import { render } from "./Home.vue?vue&type=template&id=33f82445"
const script = {}

import exportComponent from "/DATA/REPO/survey-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__